import React from 'react';
import {
  SaveButton,
  fetchEnd,
  fetchStart,
  showNotification
} from 'react-admin';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';

import DistributionListContactForm from './DistributionListContactForm';
import DialogTitleWithCloseButton from '../../core/components/DialogTitleWithCloseButton';
import DistributionListApi from '../../core/apis/DistributionListApi';
import MailApi from '../../core/apis/MailApi';
import { defaultTo } from 'lodash';
import { getIcError } from '../../core/providers/utils';

class DistributionListContactDialog extends React.Component {
  userEmailsFormProps;

  state = {
    submitting: false
  };

  setUserEmailsFormProps = props => {
    this.userEmailsFormProps = props;
  };

  handleSaveClick = event => {
    // Trigger a submit of our custom quick create/update form
    // This is needed because our modal action buttons are oustide the form
    this.userEmailsFormProps.form.submit(event);
  };

  handleClose = () => {
    const { handleDialogToggle } = this.props;
    const { submitting } = this.state;
    if (submitting) return;
    this.userEmailsFormProps.form.reset();
    handleDialogToggle();
  };

  splitEmails = value => {
    if (value && value.length > 0) {
      const emailParts = value.split(';');
      const mailDto = [];
      for (var i = 0; i <= emailParts.length - 1; i++) {
        var emailAddress = emailParts[i].trim();
        if (emailAddress !== '') {
          mailDto.push({
            name: null,
            address: emailAddress
          });
        }
      }
      return mailDto;
    }
    return [];
  };

  getBase64 = file => {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function() {
        var b64 = reader.result.replace(/^data:.+;base64,/, '');
        resolve(b64);
      };
    });
  };

  handleSubmit = async values => {
    const {
      fetchStart,
      fetchEnd,
      handleDialogToggle,
      formData,
      distributionListId,
      showNotification,
      deliveryTab,
      filters
    } = this.props;
    this.setState({ submitting: true });

    if (values && values.users && values.users.length < 1) {
      showNotification('At least one contact must be selected.', 'error');
      this.setState({ submitting: false });
      return;
    }

    // prepare attachments for API
    const emailAttachments = await defaultTo(formData.attachments, []).map(
      async item => {
        let base64Content = await this.getBase64(item.rawFile);
        return {
          content: base64Content,
          mimeType: item.type,
          fileName: item.title,
          disposition: null,
          contentId: null
        };
      }
    );

    if (deliveryTab) {
      //delivery tab email
      const { resourceuploadId, notificationMethod = 'REPORTING' } = this.props;
      const groupsDict = {};
      const sendingList = formData.selectedItems.reduce((acc, item) => {
        let obj = values.users.find(o => o === item.email);
        if (obj) {
          const groupId = `${item.documentId}:${item.fundId}:${item.investorId}`;
          let group = groupsDict[groupId];

          if (group === undefined) {
            group = {
              documentId: item.documentId,
              documentFileName: item.documentFileName,
              fundId: item.fundId,
              investorId: item.investorId,
              users: [
                {
                  userId: item.userId,
                  email: item.email,
                  firstname: item.firstname,
                  lastname: item.lastname,
                  fax: item.fax,
                  address: item.address
                }
              ]
            };

            groupsDict[groupId] = group;
            acc.push(group);
          } else {
            group.users.push({
              userId: item.userId,
              email: item.email,
              firstname: item.firstname,
              lastname: item.lastname,
              fax: item.fax,
              address: item.address
            });
          }
        }
        return acc;
      }, []);
      const listToSend = {
        resourceUploadId: resourceuploadId,
        notificationMethod: notificationMethod,
        from: {
          fromAddress: {
            name: formData.alias,
            address: formData.from
          },
          replyToAddress: {
            name: null,
            address: formData.aliasTo
          },
          rememberEmailAddressAlias: !!formData.rememberMe
        },
        to: sendingList,
        subject: formData.subject,
        msgBody: formData.msgBody,
        attachments: await Promise.all(emailAttachments),
        isTestEmail: true
        // attachments: await Promise.all(attachments)
      };

      // Dispatch an action letting react-admin know a API call is ongoing
      fetchStart();

      const resultOperation = MailApi.create(listToSend);

      resultOperation
        .then(() => {
          showNotification('ra.notification.distribution_email_sent', 'info');

          handleDialogToggle();
        })
        .catch(error => {
          showNotification('ra.notification.server', 'error', {
            messageArgs: { message: getIcError(error) }
          });
        })
        .finally(() => {
          // Dispatch an action letting react-admin know a API call has ended
          this.userEmailsFormProps.form.reset();
          fetchEnd();
          this.setState({ submitting: false });
        });
    } else {
      //distribution list email
      const distributionListRecipients = values.users.map(item => {
        let obj = formData.selectedItems.find(o => o.email === item); // search by email
        return {
          userId: obj.userId,
          name: `${obj.firstName} ${obj.lastName}`,
          emailAddress: obj.email,
          fundId: obj.fundId,
          ccEmails: obj.ccEmails,
          investorId: obj.investors.length === 1 ? obj.investors[0].id : '*'
        };
      });

      let body = {
        distributionListRecipients,
        sendEmailDto: {
          from: {
            fromAddress: {
              name: formData.alias,
              address: formData.from
            },
            replyToAddress: {
              name: null,
              address: formData.aliasTo
            },
            rememberEmailAddressAlias: !!formData.rememberMe
          },
          cc: this.splitEmails(formData.cc),
          bcc: this.splitEmails(formData.bcc),
          subject: formData.subject,
          msgBody: formData.msgBody,
          attachments: await Promise.all(emailAttachments),
          isTestEmail: true
        },
        filters: filters
      };

      if (distributionListId) {
        body = { ...body, distributionListId };
      }

      // Dispatch an action letting react-admin know a API call is ongoing
      fetchStart();

      const resultOperation = DistributionListApi.sendMail(body);

      resultOperation
        .then(() => {
          showNotification('ra.notification.distribution_email_sent', 'info');
          handleDialogToggle();
        })
        .catch(error => {
          showNotification('ra.notification.server', 'error', {
            messageArgs: { message: getIcError(error) }
          });
        })
        .finally(() => {
          // Dispatch an action letting react-admin know a API call has ended
          this.userEmailsFormProps.form.reset();
          fetchEnd();
          this.setState({ submitting: false });
        });
    }
  };

  render() {
    const { showDialog, formData } = this.props;
    const { submitting } = this.state;

    return (
      <Dialog
        fullWidth
        open={!!showDialog}
        aria-label={`Test Email`}
        maxWidth={false}
        onClose={(event, reason) => {
          if (reason === 'backdropClick') return null;
          this.handleClose();
        }}
      >
        <DialogTitleWithCloseButton onClose={this.handleClose}>
          {'Test Email'}
        </DialogTitleWithCloseButton>
        <DialogContent>
          <DistributionListContactForm
            {...this.props}
            setUserEmailsFormProps={this.setUserEmailsFormProps}
            handleSubmit={this.handleSubmit}
            recipients={formData.selectedItems}
          />
        </DialogContent>
        <DialogActions>
          <SaveButton
            saving={submitting}
            handleSubmitWithRedirect={this.handleSaveClick}
            label={'Send Test Email'}
            icon={<></>}
          />
          <Button
            onClick={this.handleClose}
            variant="outlined"
            color="primary"
            disabled={submitting}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapDispatchToProps = {
  fetchEnd,
  fetchStart,
  showNotification
};

export default connect(null, mapDispatchToProps)(DistributionListContactDialog);
